#import "@/apollo/fragments/Client.gql"
#import "@/apollo/fragments/TemporaryUploadConfig.gql"
query Clients($orderBy: ClientOrderBy, $wppProjectId: String) {
    clients: clientsByWppProjectId(orderBy: $orderBy, wppProjectId: $wppProjectId) {
        ...Client
        mastheadUploadConfig {
            ...Config
        }
        fbAdsManagerConfig {
            businessId
            adAccountId
        }
    }
}
